import React, { Component } from 'react';
import Navbar from './Navbar';
import Slider from './Slider';
import Timeline from './Timeline';
import Certificates from './Certificates';
import CertificatesPage from './CertificatesPage';
import About from './About';
import Offers from './Offers';
import News from './News';
import Contact from './Contact';
import HomePage from './HomePage';
import WorkPage from './WorkPage';
import TendersPage from './TendersPage';
import Rodo from './Rodo';
import './App.css';
import './Navbar.css';
import './Slider.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "typeface-roboto";
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom';
import { Helmet } from 'react-helmet';


class App extends Component{
  constructor(){
    super();
    this.state = {
      navbar: [
        {id: 1, name: "O nas"},
        {id: 2, name: "Oferta"},
        {id: 3, name: "Aktualności"},
        {id: 4, name: "Przetargi"},
        {id: 5, name: "RODO"},
        {id: 6, name: "Praca"},
        {id: 7, name: "Kontakt"}
      ]
    }
  }

  render(){
    // const navbar = this.state.navbar.map(el => {
    //   return <Navbar key={el.id} name={el.name} />;
    // });
    return (
      <div className="app">
        <Helmet>
          <title>Coveris Rypin Sp. z o.o.</title>
        </Helmet>
        <Navbar />
        <Slider />    
        <Router>
          <Route exact path="/" component={HomePage} />
          <Route path="/praca" component={WorkPage} />
          <Route path="/przetargi" component={TendersPage} />
          <Route path="/rodo" component={Rodo} />
          <Route path="/certyfikaty" component={CertificatesPage} />
        </Router>
      </div>
    );
  }
}


export default App;
